const experience = {
  header: {
    overline: "PARCOURS PROFESSIONNEL",
    titlePrefix: "Construire l’",
    titleHighlight: "excellence",
    titleSuffix: "par l’expérience",
    subtitle:
      "Un parcours orienté impact : solutions IA à forte valeur et architectures numériques robustes dans des secteurs variés.",
  },
  current: "En poste",
  present: "Présent",
  sections: {
    technologies: "Technologies clés",
    skills: "Compétences professionnelles",
  },
  footer: {
    titlePrefix: "Transformer l’expérience en",
    titleHighlight: "avantage compétitif",
    subtitle:
      "Mon parcours me permet de relier complexité technique et valeur business, pour faire des projets IA de vrais produits robustes — pas seulement de la recherche.",
    downloadCv: "Télécharger le CV complet",
  },
};

export default experience;
